import { Link } from "react-router-dom";
import { COMPANY_INFO } from "../data/siteData";

export default function CtaBanner() {
  return null;
}
